var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWearTear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 51,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "wearTear_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BDC5",
    stopOpacity: 0.7,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7 3C20 3 11.7 5 7.4 9.2c-8.8 9.5 0 37 22.3 37s28-19.1 27.5-28.4C56.4 5.8 39.3 3 29.7 3z",
    fill: "url(#wearTear_svg__a)",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 1C19.4 1 9.8 3.4 5 8c-10.2 11-.1 42 25.4 42C56 50 62.6 28.3 62 17.8 61 4.3 41.5 1 30.4 1z",
    stroke: "#2196F3",
    strokeWidth: 2,
    strokeDasharray: 3.2
  }))));
}
export default SvgWearTear;